import { loginIn } from './user'
/**
 * 初始化样式
 */
function initStyles() {
  // 创建样式
  const styles = document.createElement('style')
  // 样式内容
  styles.innerHTML = `
  .app-login{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999999;
    background-color: rgba(0, 0, 0, .4);
  }
  .app-login__main{
    width: 10rem;
    // height: 6rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: #fff;
    border-radius: 0.6rem;
    font-size: 0.7rem;
    text-align: center;
    padding: 0.4rem 0.5rem 0.8rem;
  }
  .app-login__main p{
    padding: 0.5rem 0 0.8rem;
    color: #4c4c4c
  }
  .app-login__btn{
    background-color: #00c07b;
    background-image: linear-gradient(to right,#00bf63,#01c192);
    display: block;
    width: 84%;
    height: 2.3rem;
    margin: 0 auto;
    border-radius: 0.6rem;
    color: #fff;
    font-size: 0.7rem;
    text-align: center;
  }
  .app-login__btn:active{
    transform: scale(1.1)
  }`
  // 插入
  document.head.appendChild(styles)
}
initStyles()
let loginEl = null
/**
 * 显示登陆弹窗
 */
export function loginPage(needHide) {
  return new Promise((resolve) => {
    // 判断是否存在
    if(!(loginEl = document.querySelector('.app-login'))) {
      loginEl = document.createElement('div')
      loginEl.classList.add('app-login')
      loginEl.innerHTML = `<div class="app-login__main">
        <p>你还未登陆，请先点击登陆</p>
        <button class="app-login__btn">登陆</button>
      </div>`
      document.body.appendChild(loginEl)
    }
    // 登陆递归
    const loopLogin = async () => {
      // 登陆接口
      const { status, memberInfo } = await loginIn()
      console.log('登陆状态', status)
      // 非登陆成功
      if (status !== '0') return await loginPage()
      else return memberInfo
    }
    loginEl.onclick = (e) => {
      // if (e.currentTa)
      const { target } = e
      // 登陆
      if (target.tagName === 'BUTTON') {
        // 直到登陆成功为止
        const result = loopLogin().then(resolve)
        // 是否需要隐藏
        if (needHide) {
          result.then(hideLoginPage)
        }
      }
    }
  })
}
/**
 * 移除登陆弹窗
 */
export function hideLoginPage() {
  console.log('隐藏')
  // 移除
  document.body.removeChild(loginEl)
}